import { BrowserRouter } from 'react-router-dom';

export const withRouter = (component: () => React.ReactNode) => () => {
  return (
    <BrowserRouter basename='/table-testing-application'>
      {component()}
    </BrowserRouter>
  );
};
